import React, {
  useCallback, useContext, useEffect,
} from 'react';
import { useDropzone } from 'react-dropzone';
import { useIntl } from 'react-intl';
import { ReactSVG } from 'react-svg';
import icone from '../../../../../../../../assets/image/upload.svg';
import './DropeZoneContactInfo.scss';
// eslint-disable-next-line import/order
import { useFormContext } from 'react-hook-form';
import { appStore } from '../../../../../../../../state/app';

const MIN_WIDTH_RES = 500;
const MIN_HEIGHT_RES = 500;
const separate = 1e+6;
const DropeZoneContactInfo = ({
  multipleFiles,
  amountFiles = 1,
  droppedFiles,
  setDroppedFiles,
  acceptedFileTypes,
  setResolutionWarning,
  setOpenCropper,
  previewCustomClass,
  setError,
  notMoreUpload,
  type = 'general',

}) => {
  const translate = useIntl();
  const { register } = useFormContext();
  const { update, state } = useContext(appStore);
  const { app } = state;
  const { onSubmitedCarbonForm, toDeleteList } = app;
  const handleIconDrop = (icon) => {
    const reader = new window.FileReader();
    reader.readAsDataURL(icon[0]);

    reader.onloadend = () => {
      const image = new Image();
      image.src = reader.result;
      image.onload = () => {
        if (image.height >= MIN_HEIGHT_RES && image.width >= MIN_WIDTH_RES) {
          setDroppedFiles(icon);
          setResolutionWarning('');
          setOpenCropper(true);
        } else {
          setResolutionWarning(translate.formatMessage({ id: 'dropZoneInput.photoResolution' })`${MIN_WIDTH_RES}x${MIN_HEIGHT_RES}`);
          setOpenCropper(false);
        }
      };
    };
  };

  const handleMultiFilesDrop = async (f) => {
    setError('');
    setDroppedFiles(f);
  };

  const onDrop = useCallback(async (acceptedFiles) => {
    const targetFiles = [...droppedFiles, ...acceptedFiles];
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onabort = (e) => console.log('file reading was aborted', e);
      reader.onerror = (e) => console.log('file reading has failed', e);
      reader.onload = () => {
        // Do whatever you want with the file contents
        // const binaryStr = reader.result;
      };
      reader.readAsArrayBuffer(file);
    });
    if (targetFiles.length >= amountFiles) {
      setError(translate.formatMessage({ id: 'carbon.error.text1' }));
      targetFiles.splice(amountFiles);
    }

    if (multipleFiles) await handleMultiFilesDrop(targetFiles);
    else handleIconDrop(acceptedFiles);
  }, [droppedFiles]);

  const validFile = (file) => {
    const unique = droppedFiles.map((el) => el.path).some((el, index, arr) => arr.includes(file.path));
    if (unique && droppedFiles.length) {
      return null;
    }
  };
  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: acceptedFileTypes,
    onDrop,
    maxSize: 10000000,
    maxFiles: amountFiles,
    multiple: false,
    validator: validFile,
  });

  const removeFile = async (file) => {
    if (!onSubmitedCarbonForm) {
      setError('');
      if (file?.id) {
        const listToDelete = [...toDeleteList];
        listToDelete.push(file.id);
        update('app.toDeleteList', listToDelete);
      }

      const newFiles = [...droppedFiles];
      newFiles.splice(newFiles.indexOf(file), 1);
      setDroppedFiles(newFiles);
    // if (newFiles.length) await handleMultiFilesDrop(newFiles);
    // else change({ filesCidDir: '' });
    }
  };

  const getMb = (size) => (size / separate).toFixed(2);
  const files = droppedFiles.map((file, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <li key={index + file.path} className={previewCustomClass}>
      {file.path}
      {file?.size && (`${' '}
      (
        ${
          getMb(file
            .size)}
      ${' '}
        mb)`)}
      <i className="icon-trash uploader__trash" onClick={() => removeFile(file, index)} />
    </li>
  ));
  useEffect(() => {
    if (fileRejections.length) {
      const { errors } = fileRejections[0];
      if (errors[0].code === 'file-too-large') {
        setError(translate.formatMessage({ id: 'carbon.error.text2' }));
      } else setError(translate.formatMessage({ id: 'carbon.error.text3' }));
    }
  }, [fileRejections]);
  // const customClass = `dropzone ${classCustom}`;
  const customCreator = `upload__creator ${multipleFiles ? 'multi' : ''}`;

  return (
    <div className={`uploader__drop-zone ${acceptedFileTypes ? 'file-types' : ''}`}>
      <div className="wizard__drop-panel">
        {droppedFiles.length > 0 && (
        <aside>
          <ul>{files}</ul>
        </aside>
        )}
        {notMoreUpload ? (
          <div className={customCreator} {...getRootProps()}>
            <div className="uploader__creator-wrapper">
              <input {...getInputProps()} name={`contactInfo.filesList.${[type]}`} {...register(`contactInfo.filesList.${[type]}`)} disabled={onSubmitedCarbonForm} />
              <span className="uploader__text">
                {translate.formatMessage({ id: 'button-uploadfile' })}
              </span>
              <ReactSVG src={icone} />
            </div>
          </div>
        ) : null}
      </div>
      {acceptedFileTypes ? <label className="wizard__file-list">{`.${acceptedFileTypes.replace(/[.]/g, ' ')} (files accepted)`}</label>
        : ''}
    </div>
  );
};

export default DropeZoneContactInfo;
